import { render, staticRenderFns } from "./SimpleLayout.vue?vue&type=template&id=55855d1e&"
import script from "./SimpleLayout.vue?vue&type=script&lang=js&"
export * from "./SimpleLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports